import AmpersandState from 'ampersand-state';

module.exports = AmpersandState.extend({
    props: {
        id: 'string',
        companyId: 'string',
        systemStatus: 'number',
        name: 'string',
        color: 'number',
        description: 'string',
        isDeleted: {
            type: 'boolean',
            default: false
        }
    },

    parse: function(obj) {
        return obj;
    },

    exportToOption() {
        return {
            value   : this.id,
            label   : this.name,
            color   : this.color
        }
    },

    toJSON() {
        return {
            id          : this.id,
            name        : this.name,
            color       : this.color,
            companyId   : this.companyId,
            systemStatus: this.systemStatus,
            description : this.description,
            isDeleted   : this.isDeleted

        }
    }


});